import type { RankingItem } from '../schemas/auth';

export const getRankUpdatesAfterDeletion = (deletedRank: number, currentItems: Array<{ id: string; rank: number }>): RankingItem[] => {
  return currentItems
    .filter((item) => item.rank > deletedRank)
    .map((item) => ({
      id: item.id,
      rank: item.rank - 1,
    }));
};

export const getRankUpdatesAfterReorder = (items: Array<{ id: string; rank: number }>): RankingItem[] => {
  const updates: RankingItem[] = [];

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const newRank = i + 1;

    if (item.rank !== newRank) {
      updates.push({
        id: item.id,
        rank: newRank,
      });
    }
  }

  return updates;
};

export const getRankUpdatesAfterInsertion = (newItemRank: number, currentItems: Array<{ id: string; rank: number }>): RankingItem[] => {
  return currentItems
    .filter((item) => item.rank >= newItemRank)
    .map((item) => ({
      id: item.id,
      rank: item.rank + 1,
    }));
};
